import { Copy } from 'lucide-react';
import { toast } from 'sonner';

import { Facebook, Linkedin, Twitter } from './social-icons';

interface ShareBlocProps {
  /** Titre affiché dans le bloc */
  title?: string;
  /** Texte partagé sur les réseaux (quote Facebook, text Twitter, subject Mail) */
  shareText: string;
  /** URL partagée — défaut : window.location.href */
  shareUrl?: string;
}

export function ShareBloc({ title = 'Partager', shareText, shareUrl }: ShareBlocProps) {
  const url = shareUrl ?? window.location.href;
  const encodedUrl = encodeURIComponent(url);
  const encodedText = encodeURIComponent(shareText);

  const socials = [
    {
      icon: Facebook,
      label: 'Facebook',
      color: 'bg-blue-100 text-blue-600 hover:bg-blue-200',
      href: `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}&quote=${encodedText}`,
    },
    {
      icon: Linkedin,
      label: 'LinkedIn',
      color: 'bg-blue-100 text-blue-700 hover:bg-blue-200',
      href: `https://www.linkedin.com/sharing/share-offsite/?url=${encodedUrl}`,
    },
    {
      icon: Twitter,
      label: 'X (Twitter)',
      color: 'bg-sky-100 text-sky-600 hover:bg-sky-200',
      href: `https://x.com/intent/tweet?url=${encodedUrl}&text=${encodedText}`,
    },
    // todo prevoir contact via formulaire pour envoi email
    // {
    //   icon: Mail,
    //   label: 'Email',
    //   color: 'bg-slate-100 text-slate-600 hover:bg-slate-200',
    //   href: `mailto:?subject=${encodedText}&body=${encodedUrl}`,
    // },
  ];

  return (
    <div className='bg-white rounded-3xl border border-slate-200 p-6'>
      <h3 className='font-bold text-lg text-slate-900 mb-4'>{title}</h3>
      <div className='flex items-center gap-3'>
        {socials.map(s => (
          <a
            key={s.label}
            href={s.href}
            target='_blank'
            rel='noopener noreferrer'
            title={s.label}
            className={`w-12 h-12 rounded-xl flex items-center justify-center transition-colors ${s.color}`}
          >
            <s.icon className='w-5 h-5' />
          </a>
        ))}
        <button
          onClick={() => {
            void navigator.clipboard.writeText(url);
            toast.success('Lien copié !');
          }}
          title='Copier le lien'
          className='w-12 h-12 rounded-xl flex items-center justify-center transition-colors bg-slate-100 text-slate-600 hover:bg-slate-200'
        >
          <Copy className='w-5 h-5' />
        </button>
      </div>
    </div>
  );
}
